import "core-js";
import React from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { HomePage } from "../AppPages/AppLayout/HomePage";
import { LoginPage } from "../LandingPages/LoginPage";
import { UnsubscribePage } from "../LandingPages/UnsubscribePage";
import CookieConsent from "react-cookie-consent";
import { getTranslate } from "react-localize-redux";

import "./App.css";

window.TestingDoms = {};
class App extends React.Component {
  render() {
    const { translate } = this.props;
    return (
      <HashRouter>
        <div className="App">
          <Switch>
            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/unsubscribe" component={UnsubscribePage} />
            <Route path="/" render={(props) => <HomePage {...props} />} />
          </Switch>
          <CookieConsent
            location="bottom"
            buttonText="Accept"
            cookieName="myAwesomeCookieName2"
            buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            expires={150}
            style={{
              background: "rgb(33,33,33)",
              justifyContent: "center",
            }}
            contentStyle={{ flex: "none" }}
          >
            {translate("COOKIE_CONSENT_MESSAGE")}
          </CookieConsent>
        </div>
      </HashRouter>
    );
  }
}

function mapStateToProps(state) {
  const { locale, alert } = state;
  return {
    alert,
    translate: getTranslate(locale),
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
